import type { Postal, PostalApi, PostalsApi, PostalsResponse } from '../../models';

const toRow = ({ id, ...postal }: PostalApi): Postal => ({
  ...postal,
  cityName: postal.cityName?.trim() ?? '',
  cityType: postal.cityType?.trim() ?? '',
  countryCode: postal.countryCode?.trim() ?? '',
  id: String(id),
  postalCode: postal.postalCode?.trim() ?? '',
  stateCode: postal.stateCode?.trim() ?? '',
});

export const normalizePostals = (result: PostalsResponse | null): PostalsApi => {
  if (result === null) {
    return { data: [], total: 0 };
  }

  return {
    data: (result.items ?? []).map(toRow),
    total: result.totalCount,
  };
};
